import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '角色大全', to: '/characters' },
  { label: '声优表', to: '/voice-actors' },
  { label: '关于本站', to: '/about' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/80 shadow-sm'
          : 'bg-background-50/60 backdrop-blur-sm border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5" aria-label="守护甜心角色百科首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-heart-3-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-bold text-foreground-900">守护甜心档案</span>
            <span className="font-label text-[11px] tracking-wide text-foreground-500">角色大全 · 声优表</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-200/70 hover:text-foreground-900'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/voice-actors"
            className="hidden whitespace-nowrap rounded-full border border-primary-500 px-4 py-2 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50 sm:inline-flex"
          >
            看声优表
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-700 hover:bg-background-200/70 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50 md:hidden">
          <nav className="flex flex-col px-4 py-3" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `rounded-lg px-4 py-3 text-sm font-medium ${
                    isActive ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}